module.exports = __webpack_public_path__ + "static/media/samuel-pontes.0e784598.png";